<div class="truckJourneyEditLoad">
    <div class="truckJourneyEditLoad-head">
        <div class="truckJourneyEditLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.load'}]"></span>
            <span> {{ truckJourneyLoad.loadId }}</span>
        </div>
        <div class="truckJourneyEditLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.deliveries'}]"></span>
            <span>&nbsp;<ng-container *ngFor="let delivery of truckJourneyLoad.deliveries; let last = last"
                ><app-delivery-number [deliveryNumber]="delivery.deliveryNumber"
                                      [salesOrderNumber]="delivery.salesOrderNumber"
                                      displayType="text"></app-delivery-number><span *ngIf="!last"> ; </span></ng-container></span>
        </div>
        <div class="truckJourneyEditLoad-head-item">
            <span class="font-bold" [i18n]="[{target: 'innerHTML', key: 'truck-journeys.detail.stops-colon'}]"></span>
            <span> {{ truckJourneyLoad.totalStops }}</span>
        </div>
    </div>
    <div class="truckJourneyEditLoad-block">
        <div *ngFor="let delivery of reorderedDeliveries; let index=index" class="truckJourneyEditLoad-line">
            <div class="truckJourneyEditLoad-line-side">
                <i [class._active]="index>0"
                   (click)="index>0 ? moveDeliveryToNewPosition(index, index-1): noop()"
                   class="fas fa-angle-up"></i>
                <div class="font-bold">{{ index + 1 }}</div>
                <i [class._active]="index<reorderedDeliveries.length-1"
                   (click)="index<reorderedDeliveries.length-1 ? moveDeliveryToNewPosition(index, index+1) : noop()"
                   class="fas fa-angle-down"></i>
            </div>
            <div class="truckJourneyEditLoad-line-item">
                <span [i18n]="'truck-journeys.detail.delivery'" class="font-bold"></span>
                <app-delivery-number [deliveryNumber]="delivery.deliveryNumber"
                                     [salesOrderNumber]="delivery.salesOrderNumber"
                                     displayType="text"></app-delivery-number>
            </div>
            <div class="truckJourneyEditLoad-line-item">
                <span [i18n]="'truck-journeys.detail.pick-colon'" class="font-bold"></span>
                <div class="truckJourneyEditLoad-line-item-block">
                    <div class="truckJourneyEditLoad-line-item-info">
                        <img [src]="delivery.pickStop.locationType === 'CHEP' ? chepDepartureIconUrl : customerDepartureIconUrl">
                        <span class="location">{{delivery.pickStop.locationLabel}}</span>
                    </div>
                    <div class="truckJourneyEditLoad-line-item-info">
                        <i class="fa fa-calendar"></i>
                        <span> {{ {dateFrom: delivery.pickStop.plannedArrival, dateTo: delivery.pickStop.plannedDeparture} | dateInterval }}</span>
                    </div>
                </div>
            </div>
            <div class="truckJourneyEditLoad-line-item">
                <span [i18n]="'truck-journeys.detail.drop-colon'" class="font-bold"></span>
                <div class="truckJourneyEditLoad-line-item-block">
                    <div class="truckJourneyEditLoad-line-item-info">
                        <img [src]="delivery.dropStop.locationType === 'CHEP' ? chepDepartureIconUrl : customerDepartureIconUrl">
                        <span class="location">{{delivery.dropStop.locationLabel}}</span>
                    </div>
                    <div class="truckJourneyEditLoad-line-item-info">
                        <i class="fa fa-calendar"></i>
                        <span> {{ {dateFrom: delivery.dropStop.plannedArrival, dateTo: delivery.dropStop.plannedDeparture} | dateInterval }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="truckJourneyEditLoad-actions">
        <button (click)="cancelEdition()" type="button" class="btn">
            <span [i18n]="'truck-journeys.detail.button.cancel'"></span>
        </button>
        <button (click)="confirmEdition()" type="button" class="btn _success">
            <span [i18n]="'truck-journeys.detail.button.confirm'"></span>
        </button>
    </div>
</div>
